module.exports = __webpack_public_path__ + "static/media/marketing-feature-tile-icon-01.6b0f6d40.svg";